import gql from 'graphql-tag';
export const fileFragment = gql `
  fragment File on File {
    id
    url
    entityType
    entityId
  }
`;
//# sourceMappingURL=File.js.map